import React from 'react';
import {
  PlusIcon,
  CircleStackIcon,
  ArrowPathIcon,
  XMarkIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

interface PanelEditorArquitectoProps {
  onAbrirCrearRack: () => void;
  pasoGrid: number;
  onCambiarPasoGrid: (paso: number) => void;
  onGuardarLayout: () => void;
  onResetLayout: () => void;
  onSalirModoArquitecto: () => void;
  guardando?: boolean;
  totalRacks: number;
}

export const PanelEditorArquitecto: React.FC<PanelEditorArquitectoProps> = ({
  onAbrirCrearRack,
  pasoGrid,
  onCambiarPasoGrid,
  onGuardarLayout,
  onResetLayout,
  onSalirModoArquitecto,
  guardando = false,
  totalRacks,
}) => {
  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 z-30 flex flex-wrap items-center gap-3 bg-slate-900/90 backdrop-blur-xl border border-cyan-500/40 px-4 py-2 rounded-2xl shadow-2xl text-xs text-white animate-fadeIn">
      {/* Indicador de Modo */}
      <div className="flex items-center gap-2 pr-3 border-r border-slate-700/80">
        <div className="p-1 rounded-lg bg-cyan-500/20 text-cyan-400">
          <SparklesIcon className="w-4 h-4" />
        </div>
        <div>
          <span className="font-extrabold text-cyan-300 block text-[11px] leading-tight">
            MODO ARQUITECTO 3D
          </span>
          <span className="text-[10px] text-slate-400 font-medium">
            {totalRacks} Racks en Planta
          </span>
        </div>
      </div>

      {/* Botón Crear Rack */}
      <button
        onClick={onAbrirCrearRack}
        className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-600 hover:bg-blue-500 rounded-xl font-bold text-white shadow-md shadow-blue-600/30 transition-all text-xs"
      >
        <PlusIcon className="w-4 h-4" />
        <span>Crear Rack</span>
      </button>

      {/* Selector de Rejilla / Snapping */}
      <div className="flex items-center gap-1.5 px-2 py-1 bg-slate-950/60 rounded-xl border border-slate-800">
        <span className="text-[10px] uppercase font-bold text-slate-400">Rejilla:</span>
        {[0.5, 1.0, 2.0].map((paso) => (
          <button
            key={paso}
            onClick={() => onCambiarPasoGrid(paso)}
            className={`px-2 py-0.5 rounded-lg text-[10px] font-bold transition-all ${
              pasoGrid === paso
                ? 'bg-cyan-500 text-slate-950'
                : 'text-slate-400 hover:text-white'
            }`}
          >
            {paso}m
          </button>
        ))}
      </div>

      <div className="w-px h-5 bg-slate-700" />

      {/* Botón Guardar */}
      <button
        onClick={onGuardarLayout}
        disabled={guardando}
        className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 rounded-xl font-bold text-white shadow-md shadow-emerald-600/30 transition-all text-xs"
      >
        <CircleStackIcon className="w-4 h-4" />
        <span>{guardando ? 'Guardando...' : 'Guardar Layout'}</span>
      </button>

      {/* Botón Reset */}
      <button
        onClick={onResetLayout}
        title="Restablecer a distribución paramétrica por defecto"
        className="p-1.5 text-slate-400 hover:text-amber-400 hover:bg-slate-800 rounded-lg transition-all"
      >
        <ArrowPathIcon className="w-4 h-4" />
      </button>

      {/* Salir del Modo Arquitecto */}
      <button
        onClick={onSalirModoArquitecto}
        className="p-1.5 text-slate-400 hover:text-white hover:bg-slate-800 rounded-lg transition-all ml-1"
        title="Finalizar Edición (Volver a Supervisión)"
      >
        <XMarkIcon className="w-4 h-4" />
      </button>
    </div>
  );
};
